<template>
  <div class="card-wrapper" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "blankcard",
  props: {
    // Props to receive
    // width ( type: Number, required: false, description: 'Width as a percentage of parent component')
    // max-width ( type:Number, required: false, description: 'Max width of the card')
    width: {
      type: Number,
      default: 100
    },
    maxWidth: {
      type: Number,
      default: 500
    },
  },
  computed: {
    style() {
      return `width:${this.width}%; max-width:${this.maxWidth}px;`;
    }
  }
};
</script>